import { EventDateRangeDto } from '@ivy-monorepo/shared'
import AdminDateRangeCalendarRow from './AdminDateRangeCalendarRow'

interface AdminEventDateRangesFieldProps {
  ranges: EventDateRangeDto[]
  onChange: (ranges: EventDateRangeDto[]) => void
}

const AdminEventDateRangesField = ({ ranges, onChange }: AdminEventDateRangesFieldProps) => {
  const updateRange = (index: number, startDate: string | null, endDate: string | null) => {
    const next = [...ranges]
    next[index] = { eventStartDate: startDate, eventEndDate: endDate }
    onChange(next)
  }

  const handleAddRange = () => {
    onChange([...ranges, { eventStartDate: null, eventEndDate: null }])
  }

  const handleRemoveRange = (index: number) => {
    onChange(ranges.filter((_, rangeIndex) => rangeIndex !== index))
  }

  return (
    <div className="admin-event-date-ranges-field">
      {ranges.length > 1 && (
        <div className="admin-event-date-ranges-field__notice">
          This will create <strong>{ranges.length} separate events</strong> — one for each date range below, all with the same
          name, content, and flyer.
        </div>
      )}

      {ranges.map((range, index) => (
        <div className="admin-event-date-ranges-field__row" key={index}>
          {ranges.length > 1 && (
            <div className="admin-event-date-ranges-field__row-header">
              <span className="admin-event-date-ranges-field__row-title">Event {index + 1}</span>
              <button type="button" className="admin-central-datetime-field__clear" onClick={() => handleRemoveRange(index)}>
                Remove
              </button>
            </div>
          )}
          <AdminDateRangeCalendarRow
            startDate={range.eventStartDate ?? null}
            endDate={range.eventEndDate ?? null}
            onChange={(startDate, endDate) => updateRange(index, startDate, endDate)}
          />
        </div>
      ))}

      <button type="button" className="styled-button cancel sm admin-event-date-ranges-field__add" onClick={handleAddRange}>
        + Add another date range
      </button>
    </div>
  )
}

export default AdminEventDateRangesField
